import React, { useState, useEffect } from 'react';
import { Card, Button, message, Alert } from 'antd';
import { useAuthStore } from '../stores/authStore';

const DebugLogin = () => {
  const { user, token } = useAuthStore();
  const [debugInfo, setDebugInfo] = useState({});

  useEffect(() => {
    // 获取URL参数
    const urlParams = new URLSearchParams(window.location.search);
    const params = {};
    for (const [key, value] of urlParams.entries()) {
      params[key] = value;
    }

    // 获取localStorage
    const localStorage = {};
    for (let i = 0; i < window.localStorage.length; i++) {
      const key = window.localStorage.key(i);
      localStorage[key] = window.localStorage.getItem(key);
    }

    setDebugInfo({
      urlParams: params,
      localStorage: localStorage,
      authStore: {
        user: user,
        token: token
      },
      timestamp: new Date().toLocaleString()
    });
  }, [user, token]);

  const [paymentTestResult, setPaymentTestResult] = useState(null);

  const testPayment = async () => {
    setPaymentTestResult('测试中...');
    try {
      const response = await fetch('/api/card-sales/mini-payment', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          orderId: 173,
          openid: localStorage.getItem('wechat_openid')
        })
      });

      const data = await response.json();
      setPaymentTestResult(JSON.stringify(data, null, 2));
      message.success('支付测试完成，结果已显示');
    } catch (error) {
      setPaymentTestResult('测试失败: ' + error.message);
      message.error('支付测试失败: ' + error.message);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <Card title="🔍 登录调试页面" style={{ marginBottom: '20px' }}>
        <Alert
          message="调试信息"
          description="这个页面用于调试登录和支付问题"
          type="info"
          style={{ marginBottom: '20px' }}
        />
        
        <div style={{ marginBottom: '20px' }}>
          <Button type="primary" onClick={testPayment}>
            测试支付接口
          </Button>
        </div>

        {paymentTestResult && (
          <div style={{ marginBottom: '20px' }}>
            <h3>支付测试结果:</h3>
            <pre style={{ 
              background: '#f5f5f5', 
              padding: '10px', 
              borderRadius: '4px',
              border: '1px solid #d9d9d9',
              maxHeight: '300px',
              overflow: 'auto'
            }}>
              {paymentTestResult}
            </pre>
          </div>
        )}

        <div style={{ marginBottom: '20px' }}>
          <h3>URL参数:</h3>
          <pre style={{ background: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
            {JSON.stringify(debugInfo.urlParams, null, 2)}
          </pre>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h3>LocalStorage:</h3>
          <pre style={{ background: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
            {JSON.stringify(debugInfo.localStorage, null, 2)}
          </pre>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <h3>AuthStore状态:</h3>
          <pre style={{ background: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
            {JSON.stringify(debugInfo.authStore, null, 2)}
          </pre>
        </div>

        <div>
          <h3>时间戳:</h3>
          <pre style={{ background: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
            {debugInfo.timestamp}
          </pre>
        </div>
      </Card>
    </div>
  );
};

export default DebugLogin;
